export default __webpack_public_path__ + "static/media/OPD_CARD_HOSPITAL_2.9c718bce.png";